import React from 'react';
export function MechanismSection() {
  const steps = [{
    num: '01',
    title: 'Desvinculación Emocional',
    description: 'Escritura terapéutica guiada (base Pennebaker). Escribir 15–20 minutos sobre la experiencia activa el procesamiento cortical, reduce el cortisol y permite que el cerebro reorganice el recuerdo con menos carga emocional. No es un diario común — son preguntas dirigidas que desbloquean lo que no pudo decirse.'
  }, {
    num: '02',
    title: 'Ritual Simbólico',
    description: 'El acto consciente que le dice al cerebro "esto terminó". La psicología conductual documenta que los rituales reducen la ansiedad porque le dan al sistema nervioso una estructura de "fin". Un ritual no olvida. Declara que la historia tiene un final.'
  }, {
    num: '03',
    title: 'Integración Consciente',
    description: 'Cerrar un ciclo no es borrarlo. Es integrarlo: reconocer lo que fue, lo que se aprendió y lo que se elige llevar hacia adelante. Esta fase convierte el cierre en crecimiento real y evita que la experiencia vuelva como "tema no resuelto".'
  }];
  return <section id="mechanism" className="py-12 md:py-16 text-center" style={{
    background: 'var(--lilac)'
  }} data-id="element-173">
      <div className="max-w-[960px] mx-auto px-5" data-id="element-174">
        <p className="text-[10px] tracking-[4px] uppercase text-center mb-2.5" style={{
        color: 'var(--rose-deep)'
      }} data-id="element-175">
          El Método de Liberación Simbólica
        </p>

        <h2 className="font-serif font-normal max-w-[600px] mx-auto mb-2" style={{
        fontSize: 'clamp(24px, 4.5vw, 42px)',
        color: 'var(--ink)'
      }} data-id="element-176">
          Un proceso de 3 pilares que trabaja
          <br data-id="element-177" />
          el cierre{' '}
          <em style={{
          color: 'var(--rose-deep)'
        }} data-id="element-178">
            donde realmente vive el dolor
          </em>
        </h2>

        <p className="text-[14px] max-w-[480px] mx-auto mb-8" style={{
        color: 'var(--ink-soft)',
        lineHeight: 1.6
      }} data-id="element-179">
          <strong style={{
          color: 'var(--ink)',
          fontWeight: 500
        }} data-id="element-180">
            Escritura terapéutica + ritual simbólico + integración consciente
          </strong>
          . No es magia. Es psicología aplicada.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-181">
          {steps.map((step, index) => <div key={index} className="fade-in p-6 md:p-7 rounded-xl text-left transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_40px_rgba(180,122,138,.2)]" style={{
          background: 'var(--white)',
          boxShadow: '0 4px 24px rgba(180,122,138,.1)'
        }} data-id="element-182">
              <div className="font-serif text-[44px] leading-none mb-1" style={{
            color: 'var(--gold)',
            opacity: 0.35
          }} data-id="element-183">
                {step.num}
              </div>
              <h3 className="font-serif text-[17px] font-medium mb-2" style={{
            color: 'var(--ink)'
          }} data-id="element-184">
                {step.title}
              </h3>
              <p className="text-[13px] leading-relaxed" style={{
            color: 'var(--muted)'
          }} data-id="element-185">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}